module.exports = "/next-static/_next/static/images/block_image_three_1x-c1f633918d1a01e83a60729f78dbe01e.webp";